module.exports = "/v2/pages/dashboard/dist/14deb20f06e19c8a281e36fbc8957709.svg";